import { SubscriptionModel } from "../../entities/billing";
import { BaseODataRepository } from "../BaseODataRepository";

export class SubscriptionODataRepo extends BaseODataRepository<SubscriptionModel> {
  protected baseUrl = `/OData/subscriptions`;
}

export default SubscriptionODataRepo;
